import { errorHandler } from '../common';
import Api from '../api';
const { axios: api } = Api;

const ENTITY_NAME = 'mail-test';

export const getMailTests = () =>
	errorHandler(async () => {
		const data = await api.get(`/${ENTITY_NAME}/`);
		return { data: data.data };
	});

export const updateMailTest = (payload) =>
	errorHandler(async () => {
		const data = await api.patch(`/${ENTITY_NAME}/${payload._id}`, payload);
		return { data: data.data };
	});

export const createMailTest = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/${ENTITY_NAME}`, payload);
		return { data: data.data };
	});
